export default __webpack_public_path__ + "static/media/document.7658c764.svg";